const getApiBaseUrl = () => {
  const location = window.location;
  const hostname = location.hostname;
  
  // For localhost or 127.0.0.1, use port 5022
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://${hostname}:5022`;
  }
  
  // For all other cases, use the same origin
  return location.origin;
};

export const getApiUrl = (endpoint) => {
  const baseUrl = getApiBaseUrl();
  return `${baseUrl}${endpoint}`;
};

// Determine environment (dev or prod) based on hostname
// This should match the backend ENVIRONMENT variable
const getEnvironment = () => {
  const hostname = window.location.hostname;
  // For localhost, 127.0.0.1, or dev tuning hosts, assume dev environment
  if (hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname.includes('tuning-dev') ||
      hostname.includes('tuning.dev')) {
    return 'dev';
  }
  // For all other cases (including all-completed.com), assume prod
  return 'prod';
};

// Extract user_id from Auth0 user object
// user_id is stored in user_metadata.{env}.user_id (where env is 'dev' or 'prod')
export const getUserId = (user) => {
  if (!user) return null;
  
  // Get the environment-specific metadata
  // Auth0 namespaces user_metadata with the API identifier/audience
  const userMetadataAll = user['http://f-proj.com/metadata']
    || user['https://all-completed.com/user_metadata'] 
    || user['https://all-completed.com/api/user_metadata']
    || user['https://tuning.all-completed.com/user_metadata'] 
    || user['https://tuning.all-completed.com/api/user_metadata']
    || user.user_metadata 
    || {};
  
  // Determine the current environment
  const environment = getEnvironment();
  
  // Access user_id from user_metadata.{env}.user_id
  const envMetadata = userMetadataAll[environment] || {};
  return envMetadata.user_id || null;
};

// Get auth headers for API requests - requires Auth0 token
// This function must be called with await and getAccessTokenSilently
export const getAuthHeaders = async (getAccessTokenSilently = null) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  
  // Get Auth0 token (required)
  if (getAccessTokenSilently) {
    try {
      const token = await getAccessTokenSilently();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
        return headers;
      }
    } catch (error) {
      console.error('Failed to get Auth0 token:', error);
      throw new Error('Authentication required. Please login with Auth0.');
    }
  }
  
  // No Auth0 token available
  throw new Error('Authentication required. Auth0 token not available.');
};

